export const formatInteractionDateTime = (dateString) => {
    if (!dateString)
        return "Unknown";
    try {
        const utcDateString = dateString.endsWith("Z") ? dateString : `${dateString}Z`;
        const date = new Date(utcDateString);
        if (isNaN(date.getTime())) {
            return "Unknown";
        }
        return date.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }
    catch (_a) {
        return "Unknown";
    }
};
export const formatLocalDateTime = (dateString) => {
    if (!dateString)
        return "Unknown";
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return "Unknown";
        }
        return date.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }
    catch (_a) {
        return "Unknown";
    }
};
export const formatCompactDate = (dateString) => {
    return formatInteractionDateTime(dateString);
};
//# sourceMappingURL=dateUtils.js.map